import { createReducer, createAction, ActionType } from 'typesafe-actions';
import { ShopToClubBannerABTestState, ShopToClubBannerABTestInitialState } from './types';

export const updateShopToClubBanner = createAction(
    '@SHOPTOCLUBBANNER/update',
    action => ({ imgSrc = '', desktopImg = '', linkUrl = '', categories = '' }) =>
        action({ imgSrc, desktopImg, linkUrl, categories })
);

export const initShopToClubBannerABTest = createAction('@SHOPTOCLUBBANNER/init', action => (categoryId: string) =>
    action({ categoryId })
);

const shopToClubBannerActionsList = { updateShopToClubBanner, initShopToClubBanner: initShopToClubBannerABTest };
export type shopToClubBannerActions = ActionType<typeof shopToClubBannerActionsList>;

export const shopToClubABTestReducer = createReducer<ShopToClubBannerABTestState, shopToClubBannerActions>(
    ShopToClubBannerABTestInitialState
)
    .handleAction(initShopToClubBannerABTest, (state, { payload }) => {
        return { ...state, categoryId: payload.categoryId };
    })
    .handleAction(updateShopToClubBanner, (state = ShopToClubBannerABTestInitialState, { payload }) => {
        const { imgSrc = '', desktopImg = '', linkUrl = '', categories = '' } = payload;
        return { ...state, imgSrc, desktopImg, linkUrl, categories };
    });
